import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center justify-center h-screen pt-20" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", null, "Temporary users are not supported anymore.", -1);
import NeedHelp from '@/components/NeedHelp.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CompleteAccount',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _hoisted_2,
                _createVNode(NeedHelp, { class: "mt-16 sm:mt-40" })
            ]));
        };
    }
});
